<template>
    <div class="parkinglot-grid-container">
        <overview-filter
            page-section="pastPromotions"
            include-date-filter
            @change="handleSelectorChange"
        />

        <div class="quick-filter-bar">
            <!-- Note: the select already has a label so that's why not specifying a for attr on this label -->
            <label class="quick-filter-bar__label"> {{ $t('general.labels.quickFilter') }}: </label>
            <v-text-field
                v-model="quickFilterText"
                @input="updatePastPromoQuickFilter"
                class="rtls-text-field rtls-text-field--white pb-2"
                :placeholder="$t('placeholders.quickFilter') | toSentenceCase"
            />
        </div>

        <promo-ag-grid
            ref="pastPromoGrid"
            :row-data="rowData"
            :column-defs="columnDefs"
            :default-col-def="defaultColDef"
            :grid-options="gridOptions"
            grid-style="width: 100%; height: 100%;"
            grid-class="ag-theme-custom__parkinglot-grid"
            dom-layout="normal"
            @grid-ready="onGridReady"
        />

        <promotion-viewer-dialog
            ref="promotion-viewer-dialog"
            :key="`promotion-viewer::${selectedPromotion._id}::${promotionToggle}`"
            :promotion="selectedPromotion"
            is-past-promotions
            @close="promotionToggle = !promotionToggle"
        />

        <v-btn
            class="status-bar__action--right"
            primary
            :disabled="allocationDialogDisabled"
            @click="openAllocationDialog"
        >
            {{ $t('parkingLot.allocateSelectedPromotions') | toSentenceCase }}
        </v-btn>

        <allocate-past-promotions
            ref="promotion-allocation-dialog"
            :promotion-ids="selectedPromotionIds"
            :has-activator="false"
            is-past-promotions
            @confirm="confirmAllocatedPromotions"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { debounce, isEmpty } from 'lodash';
import parkingLotGridMixin from '../mixins/parking-lot-grids-mixin';

export default {
    mixins: [parkingLotGridMixin],
    data() {
        return {
            where: {},
            isPastPromotions: true,
            quickFilterText: '',
        };
    },
    computed: {
        ...mapState('clientConfig', ['overviewPageConfig']),
        allocationDialogDisabled() {
            return isEmpty(this.selectedPromotionIds);
        },
    },
    created() {
        this.limit = this.overviewPageConfig.pastPromotions.maxPromotionsToLoad;
        this.identifierColumns = this.getIdentifierColumns({
            hideChannelColumns: this.overviewPageConfig.pastPromotions.hideChannelColumns,
            hideMechanicColumn: this.overviewPageConfig.pastPromotions.hideMechanicColumn,
        });
        this.detailColumns = this.getDetailsColumns({
            columnGroups: this.overviewPageConfig.pastPromotions.detailColumns,
        });

        this.columnDefs = [
            ...this.identifierColumns,
            ...this.getActionColumns({
                isPastPromotions: true,
                disableExpandPastPromotions: this.overviewPageConfig.pastPromotions
                    .disableExpandPastPromotions,
            }),
            ...this.detailColumns,
            {
                minWidth: 40,
                width: 40,
                flex: 1,
                checkboxSelection: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                headerClass: 'last-header',
            },
        ];
    },
    methods: {
        async handleSelectorChange({ where }) {
            this.where = where;
            this.refetchPromotions();
        },

        confirmAllocatedPromotions() {
            this.selectedPromotionIds = [];
        },

        updatePastPromoQuickFilter: debounce(function() {
            this.$refs.pastPromoGrid.gridOptions.api.setQuickFilter(this.quickFilterText);
        }, 100),
    },
};
</script>

<style lang="scss">
@import '@style/base/_variables.scss';
@import '@style/base/_mixins.scss';

.quick-filter-bar {
    @include promo-component-border($top: true);

    width: 100%;
    padding: 1rem 0 0 1rem;
    display: flex;
    background-color: $promo-table-white-bg-colour;

    &__label {
        color: $filter-bar-text-colour;
        line-height: 2.8rem;
        font-size: 1.4rem;
        font-weight: 300;
        margin-right: 1rem;
    }

    .rtls-text-field {
        max-width: 40rem;
    }
}
</style>
